import { GlLink, GlPopover, GlIcon } from '@gitlab/ui';
import HelpIcon from '~/vue_shared/components/help_icon/help_icon.vue';
export default {
    name: 'ApprovalCheckPopover',
    components: {
        GlLink,
        GlPopover,
        GlIcon,
        HelpIcon
    },
    props: {
        documentationLink: {
            type: String,
            required: false,
            default: ''
        },
        documentationText: {
            type: String,
            required: false,
            default: ''
        },
        title: {
            type: String,
            required: true
        },
        text: {
            type: String,
            required: false,
            default: ''
        },
        popoverId: {
            type: String,
            required: true
        }
    }
};
